import type { NextPage } from 'next';
import Link from 'next/link';
import { Page } from '../components';
import PageContainer from '../components/PageContainer/PageContainer';


const SomePage: NextPage = () => {

  return (
    <Page title="Отчётность АО Все Инженерные Системы">
      <PageContainer>
        <h2>Отчётность</h2>

        <p>
          <Link href="https://d3e33688-c64b-434b-9a42-876d8e59ca92.selstorage.ru/static/ao_reports/%D0%93%D0%BE%D0%B4%D0%BE%D0%B2%D0%BE%D0%B8%CC%86%20%D0%BE%D1%82%D1%87%D0%B5%D1%82_%D0%90%D0%9E%20%D0%92%D1%81%D0%B5%20%D0%B8%D0%BD%D0%B6%D0%B5%D0%BD%D0%B5%D1%80%D0%BD%D1%8B%D0%B5%20%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D1%8B_2025.docx">
Годовой отчет АО Все инженерные системы 2025</Link>
          <br />
          <Link href="https://d3e33688-c64b-434b-9a42-876d8e59ca92.selstorage.ru/static/ao_reports/%D0%93%D0%BE%D0%B4%D0%BE%D0%B2%D0%BE%D0%B8%CC%86%20%D0%BE%D1%82%D1%87%D0%B5%D1%82_%D0%90%D0%9E%20%D0%92%D1%81%D0%B5%20%D0%B8%D0%BD%D0%B6%D0%B5%D0%BD%D0%B5%D1%80%D0%BD%D1%8B%D0%B5%20%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D1%8B_2026.docx">Годовой отчет АО Все инженерные системы 2026</Link>
        </p>
      </PageContainer>
    </Page>
  );
};


export default SomePage;
